import { VariablesOf } from '@graphql-typed-document-node/core';
import { queryOptions } from '@tanstack/react-query';

import { datoRequester } from 'queries/requesters';
import {
  FooterDocument,
  LoyaltyInformationDocument,
  PrivacyPolicyDocument,
  SeoTitleSuffixDocument,
  SocialLinksFragment,
  StoreLinksFragment,
  TermsOfServiceDocument,
} from 'types/api/dato-operations.types';

const GLOBAL_PREFIX = 'global';

export const seoTitleSuffixQuery = () =>
  queryOptions({
    queryKey: [GLOBAL_PREFIX, 'seo'],
    queryFn: async (ctx) => {
      const { _site } = await datoRequester(SeoTitleSuffixDocument)(ctx);

      return { seoTitleSuffix: _site.globalSeo?.titleSuffix ?? '' };
    },
  });

export const privacyPolicyQuery = (
  variables: VariablesOf<typeof PrivacyPolicyDocument>,
) =>
  queryOptions({
    queryKey: [GLOBAL_PREFIX, 'privacy-policy', variables],
    queryFn: datoRequester(PrivacyPolicyDocument, variables),
  });

export const termsOfServiceQuery = (
  variables: VariablesOf<typeof TermsOfServiceDocument>,
) =>
  queryOptions({
    queryKey: [GLOBAL_PREFIX, 'terms-of-service', variables],
    queryFn: datoRequester(TermsOfServiceDocument, variables),
  });

export const loyaltyInformationQuery = (
  variables: VariablesOf<typeof LoyaltyInformationDocument>,
) =>
  queryOptions({
    queryKey: [GLOBAL_PREFIX, 'loyalty-information', variables],
    queryFn: datoRequester(LoyaltyInformationDocument, variables),
  });

export const footerQuery = (variables: VariablesOf<typeof FooterDocument>) =>
  queryOptions({
    queryKey: [GLOBAL_PREFIX, 'footer', variables],
    queryFn: async (ctx) => {
      const { footer } = await datoRequester(FooterDocument, variables)(ctx);

      const storeLinks: StoreLinksFragment = {
        appleStoreUrl: footer?.appleStoreUrl,
        googlePlayUrl: footer?.googlePlayUrl,
      };

      const socialLinks: SocialLinksFragment = {
        facebook: footer?.facebook,
        instagram: footer?.instagram,
        linkedin: footer?.linkedin,
        twitter: footer?.twitter,
        snapchat: footer?.snapchat,
      };

      return { storeLinks, socialLinks, footerLinks: footer?.footerLinks };
    },
  });
